function get_url() {
    return window.location.protocol + '//' + window.location.host + window.location.pathname;
}

function get_query_string(url) {

    if(typeof(url) === 'undefined') {
        url = window.location.search;
    }

    url = url.substr(1).split('&');
    if (url === "") return {};
    var b = {};

    for (var i = 0; i < url.length; ++i) {
        var p=url[i].split('=', 2);
        if (p.length === 1)
            b[p[0]] = "";
        else
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
    }

    return b;

}

function unset_unused(data) {

    for (var key in data) {
        if(data.hasOwnProperty(key) && (data[key] === "" || data[key] === undefined)) {
            delete data[key];
        }
    }

    return data;
}

function ajax_call(method, url, data, callback, $target_container, show_loader, async, extra_opts, auto_data) {

    if(typeof(data) === 'undefined') {
        data = {};
    }

    if(typeof($target_container) === 'undefined') {
        $target_container = $('body');
    }

    if(typeof(show_loader) === 'undefined') {
        show_loader = false;
    }

    if(typeof(async) === 'undefined') {
        async = true;
    }

    if(typeof(extra_opts) === 'undefined') {
        extra_opts = false;
    }

    if(typeof(auto_data) === 'undefined') {
        auto_data = true;
    }

    var $loader = $target_container.find('.loader').first();

    //Let the server know this is an ajax call
    if(auto_data) {
        data.ajax = true;

        //Add CSRF token to call
        data.csrf_token = $("input[name=csrf_token]").val();

        //If token not found, use variable value
        if(typeof(data.csrf_token) === 'undefined' || data.csrf_token === null) {
            data.csrf_token = token;
        }
    }

    //Set ajax options
    var opts = {
        method: method,
        url: url,
        data: data,
        async: async,
        success: function(resp) {

            //Hide loading icon if enabled
            if(show_loader) {
                $loader.fadeOut(fade_speed);
            }

            //Run the callback function
            if(typeof(callback) !== 'undefined') {
                callback(resp);
            }

        },
        error: function(xhr, status, error) {

            //Hide loading icon if enabled
            if(show_loader) {
                $loader.fadeOut(fade_speed);
            }

            //Unauthorised access - show error
            if(xhr.status === 401) {

                //Get response and parse it
                var resp = $.parseJSON(xhr.responseText);

                //Show alert box
                alert(resp.message);
                window.location.reload();
                return;
            }

            //Show error message
            if(xhr.responseText) {
                alert(xhr.responseText);
            }

        }
    };

    //Show loading icon if enabled
    if(show_loader) {
        $loader.fadeIn(fade_speed);
    }

    if(extra_opts) {
        $.extend(opts, extra_opts);
    }

    //Make the call
    return $.ajax(opts);

}

function get_listing_data(target_page, excluded_fields) {
    var data;

    //Get query string data from current url
    data = get_query_string();

    //Get current filter options
    data['phrase'] = $('input[name=phrase]').val();

    //Get selected view
    data['view'] = $('.filter-view .filter-view__icon--active').data('view');

    //Get sort data
    data['sort_by'] = $('input[name=sort_by]').val();
    data['sort_order'] = $('input[name=sort_order]').val();

    //If no target page, use current one
    if(typeof(target_page) === 'undefined') {
        data['page'] = $.trim($('.pagination__item--active').html());
    } else {
        data['page'] = target_page;
    }

    //Delete fields we wish to exclude
    if(typeof(excluded_fields) !== 'undefined') {
        for(var i = 0; i < excluded_fields.length; i++) {
            console.log(excluded_fields[i]);
            delete data[excluded_fields[i]];
        }
    }

    //Delete unused data/params
    data = unset_unused(data);

    return data;

}

function update_sorted($field) {

    var $sort_by = $("input[name=sort_by]");
    var $sort_order = $("input[name=sort_order]");

    //Clear existing selected class from all columns
    $field.addClass('table-row--active');

    //Update sort by field dropdown
    $sort_by.val($field.attr('id'));

    //Get sort order for selected column
    var sort_order = $field.find('i[data-order=' + $field.attr('data-order') + ']').attr('data-order');

    //Set new sort order based on current one
    if(sort_order === "unsorted") {
        $field.attr('data-order', 'asc');
        $field.addClass('selected');
        $sort_order.val('asc');

    } else if(sort_order === "asc") {
        $field.attr('data-order', 'desc');
        $field.addClass('selected');
        $sort_order.val('desc');

    } else if(sort_order === "desc") {
        $field.attr('data-order', 'unsorted');
        $field.removeClass('selected');
        $sort_order.val('');
        $sort_by.val('');
    }

}

function get_listing(data) {
    var url = $(".listing-filter").find('input[name=url]').val();

    if(data['phrase']) {
        $('.listing-filter .search__loading').show();
    }

    //Get the requested HTML
    ajax_call('get', url, data, function(resp) {

        //Load response HTML into container element
        $("main").html(resp);
        init_basic_tooltips();

        if(data['phrase']) {
            $('.listing-filter .search__close').show();
        } else {
            $('.listing-filter .search__close').hide();
        }

        $('.listing-filter .search__loading').hide();

    });

}

function show_alert(success, msg, $context) {

    if(typeof($context) === 'undefined') {
        $context = $('body');
    }

    var $alert = $context.find('.alert.form-alert').first();
    var html = '';

    if(success) {
        $alert.removeClass('alert-danger').addClass('alert-success');
    } else {
        $alert.removeClass('alert-success').addClass('alert-danger');
    }

    //Make message into array if not already
    if(msg.constructor !== Array) {
        msg = [msg];
    }

    //Loop over messages
    for(var i = 0; i < msg.length; i++) {

        //Build html from messages
        html += '<p>' + msg[i] + '</p>';

    }

    //Add final html to alert
    $alert.html(html);

    //Remove animation classes
    $alert.removeClass('bounce');

    //Re-add them (have to delay or it won't replay)
    setTimeout(function() {
        $alert.addClass('bounce');
    }, 50);

}

function hide_alert() {
    var $alert = $('.alert.form-alert');

    //Remove all content (if empty it will hide)
    $alert.html('');

    //Remove classes
    $alert.removeClass('bounce alert-danger alert-success');
}

function get_element_pos($element) {

    if($element.length > 0) {
        return $element.offset().top;
    }

}

function scroll_to_pos(pos, speed) {

    //Default to 0 if not set
    if(typeof(pos) === 'undefined') {
        pos = 0;
    }

    //Default to 1000 if not set
    if(typeof(speed) === 'undefined') {
        speed = 1000;
    }

    //If not already at the desired position...
    if($(document).scrollTop() !== pos) {

        //Scroll to position
        $("html, body").animate({
            scrollTop: pos
        }, speed);

    }
}

function get_scale() {
    if ('URLSearchParams' in window) {
        var searchParams = new URLSearchParams(window.location.search);
        return parseFloat(searchParams.get("scale"));
    }
}

function scale_values(scale) {

    var $elements = $('.scale-me');

    $elements.each(function(i, e) {

        var original = $(this).data('original');

        if(original) {
            var val = Math.round(original * scale * 100) / 100;

            if($(this).is('input')) {
                $(this).val(val);
            } else {
                $(this).html(val);
            }

            if ('URLSearchParams' in window) {
                var searchParams = new URLSearchParams(window.location.search)
                searchParams.set("scale", scale);
                var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
                history.pushState(null, '', newRelativePathQuery);
            }

            if($("#scaler option[value='" + scale + "']").length <= 0) {
                $('#scaler').append("<option value='" + scale + "'>" + scale + "x " + lang['scale'] + "</option>");
            }

            $('#scaler').val(scale).trigger('chosen:updated');

        }

    })

}

function show_fullscreen_modal() {
    $('.fullscreen-modal').show();
    $('.fullscreen-close').show();
}

function close_fullscreen_modal() {
    $('.fullscreen-modal').hide();
    $('.fullscreen-close').hide();
}

$(function() {

    $body.on('click', '.fullscreen-close', function(e) {
        e.preventDefault();
        close_fullscreen_modal();
    });

    $body.on('click', '.dismiss-changelog', function(e) {
        $(this).closest('.tippy-popper').fadeOut(200);

        ajax_call('post', '/admin/reset_changelog', {}, function(resp) {

        });

    });

    //Set scale (if there is one)
    var scale = get_scale();
    if(scale) {

        if($("#scaler option[value='" + scale + "']").length <= 0) {
            $('#scaler').append("<option value='" + scale + "'>" + scale + "x " + lang['scale'] + "</option>");
        }

        $('#scaler').val(scale).trigger('chosen:updated').trigger('change');
    }

    //Listener for scale qtys
    $('body').on('focus', '[contenteditable]', function() {
        const $this = $(this);
        $this.data('before', $this.html());
    }).on('blur paste', '[contenteditable]', function() {
        const $this = $(this);
        if ($this.data('before') !== $this.html()) {
            $this.data('before', $this.html());
            $this.trigger('change');
        }
    });

    //Listener for scale inputs
    $('.scale-me[contenteditable]').on('change', function(e) {
        var original = $(this).data('original');
        var value = e.currentTarget.textContent;

        var scale = Math.round((value / original) * 1000) / 1000;

        if(isNaN(scale) || scale === 0) {
            $(this).html(original);
            return false;
        }
        if(scale !== get_scale()) {
            scale_values(scale);
        }

    });

});
